var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvasWrap",attrs:{"styleName":"courseware_canvas_layer"}},[_c('canvas',{attrs:{"id":"canvas","width":_vm.pptSize.width,"height":_vm.pptSize.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }